import React from "react";
import ListEmploymentType from "../../../containers/Settings/EmploymentType/index";
const SettingEmploymentType = () => {
  return <ListEmploymentType />;
};
export default SettingEmploymentType;
